import EditorContainer from "../../containers/Editor";
import PreviewContainer from "../../containers/Preview";
import { MakerPageWrapper } from "./style";

const Maker = () => {
  return (
    <MakerPageWrapper>
      <EditorContainer />
      <PreviewContainer />
    </MakerPageWrapper>
  );
};

export default Maker;
